import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { RecognitionAuditDetailScreen } from "../../features/recognition-audits/recognition-audit-detail-screen";

export function createRecognitionAuditDetailRoute(
  dependencies: AdminDashboardDependencies,
): AdminRouteObject {
  return {
    path: "recognition-audits/:recognitionRunId",
    element: <RecognitionAuditDetailScreen dependencies={dependencies} />,
  };
}
